import { render } from "./AdBanners.vue?vue&type=template&id=415380e6"
import script from "./AdBanners.vue?vue&type=script&lang=js"
export * from "./AdBanners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__